// removed by extract-text-webpack-plugin
module.exports = {"root":"Footer__root___2vMKV","root--basic":"Footer__root--basic___3hkWy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Footer/Footer.scss
// module id = 1020
// module chunks = 0